"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textWrapper = exports.iconStyle = exports.iconWrapper = exports.tabWrapperStyles = exports.tabMainWrapper = exports.tabStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var tabStyles = function tabStyles(theme, active, disabled, index, size, vertical) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;align-items:center;justify-content:center;flex-wrap:wrap;width:57px;height:57px;border-radius:6px;cursor:pointer;font-size:", _styleConsts.font.size[size] || '14px', ";transition:background-color 0.25s;color:", theme.color.black3, ";outline:none;", active &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("background-color:", theme.color.accentBackground, ";color:", theme.color.accent, ";"), "\n  ", disabled &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("opacity:", theme.disabledOpacity, ";outline:0;cursor:not-allowed;&:hover{border-bottom:none;}"), "\n  ", !vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("border-bottom:none;margin-right:20px;&:last-child{margin-right:0;}"), "\n    ", vertical &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("margin-bottom:20px;&:last-child{margin-bottom:0;}"))
  );
};

exports.tabStyles = tabStyles;
var tabMainWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("position:relative;");
exports.tabMainWrapper = tabMainWrapper;

var tabWrapperStyles = function tabWrapperStyles(theme, vertical) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;", vertical ?
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:100%;flex-direction:column;") :
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;"))
  );
};

exports.tabWrapperStyles = tabWrapperStyles;
var iconWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;width:100%;align-items:center;justify-content:center;");
exports.iconWrapper = iconWrapper;

var iconStyle = function iconStyle(theme, checked) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;width:100%;align-items:center;justify-content:center;", checked &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", theme.color.accent, ";"), ";", !checked &&
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", theme.color.black3, ";"), ";")
  );
};

exports.iconStyle = iconStyle;
var textWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;width:100%;align-items:center;justify-content:center;");
exports.textWrapper = textWrapper;